import { useCallback, useState } from 'react'

export function useMultiSelectList<Item>({
  items,
  selectionPrimaryKey,
}: {
  items: Item[]
  selectionPrimaryKey: keyof Item
}) {
  const [selectionMap, setSelectionMap] = useState<Record<string, boolean>>({})

  const deleteSelection = (pkValue: string) =>
    setSelectionMap({ ...selectionMap, [pkValue]: false })

  const setSelection = useCallback(
    (pkValue: string, selected: boolean) =>
      setSelectionMap(map => ({ ...map, [pkValue]: selected })),
    [],
  )

  const selectedItems = items.filter(item => {
    const pkValue = item[selectionPrimaryKey]
    // @ts-ignore
    return selectionMap[pkValue]
  })

  const resetSelection = useCallback(() => setSelectionMap({}), [])
  const hasSelection = selectedItems?.length > 0

  return {
    selectionMap,
    setSelection,
    deleteSelection,
    resetSelection,
    selectedItems,
    hasSelection,
  }
}
